import { default as React } from 'react';
import MedicationList from '../../Images/no-medication-list.svg';
import styles from './NoMedicationList.module.scss';

export const NoMedicationList: React.FC<{
    title: React.ReactNode;
    info?: string;
}> = props => {
    return (
        <div className={styles.placeholder}>
            <div className={styles.placeholderContent}>
                <img src={MedicationList} alt='nothing-found' />
                <div className={styles.placeholderTitleText}>{props.title}</div>
                {props.info && <div className={styles.placeholderText}>{props.info}</div>}
            </div>
        </div>
    );
};
